var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResursiKnjiga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6,.cls-7{fill:none;stroke-width:1.5px;}.cls-1{stroke:#aa6276;stroke-miterlimit:10;}.cls-2{fill:#159497;}.cls-3{fill:#aa6276;}.cls-4{fill:#fa7268;}.cls-5{fill:#6e5dd8;}.cls-6{stroke:#fff;}.cls-6,.cls-7{stroke-linecap:round;stroke-linejoin:round;}.cls-7{stroke:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 300,
    cy: 254.31,
    rx: 255.16,
    ry: 38.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 77.04,
    cy: 58.68,
    r: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 520.36,
    y: 137.93,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M467.27,245.82a58.81,58.81,0,0,1,0-83.22L331.88,185l-45.44,44.92,45.44,38.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M332,185l135.23-22a34.44,34.44,0,0,1,0-48.74L332,136.22l-35.88,20.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332,185a34.44,34.44,0,0,1,0-48.74l-182.41-22a34.43,34.43,0,0,0,0,48.74Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "149.63 114.23 332.04 136.22 467.27 114.23 284.83 98.91 149.63 114.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332,136.6l135.23-22a34.46,34.46,0,0,1,0-48.75L332,87.85,296.16,108.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M332,136.6a34.46,34.46,0,0,1,0-48.75l-182.41-22a34.44,34.44,0,0,0,0,48.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.32,116.63a34.44,34.44,0,0,1,0-48.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.24,118.6a34.46,34.46,0,0,1,0-48.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.32,166.31a34.46,34.46,0,0,1,0-48.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M232.31,173.46a34.44,34.44,0,0,1,0-48.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M287.29,179.28a34.46,34.46,0,0,1,0-48.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.88,268.19a58.82,58.82,0,0,1,0-83.23L150,162.6a58.81,58.81,0,0,0,0,83.22Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "149.63 65.87 332.04 87.85 467.27 65.87 284.83 50.54 149.63 65.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 332.04,
    y1: 87.85,
    x2: 149.63,
    y2: 65.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 332.04,
    y1: 136.22,
    x2: 149.63,
    y2: 114.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "381.72 214.58 417.31 209.93 417.31 276.7 399.51 257.02 381.72 282.46 381.72 214.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.08,249.28a58.91,58.91,0,0,1,0-83.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.89,252.64a58.91,58.91,0,0,1,0-83.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 332.04,
    y1: 184.58,
    x2: 149.63,
    y2: 162.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 339.56,
    y1: 220.5,
    x2: 449.97,
    y2: 205.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "85.87 191.57 79.56 202.48 92.17 202.48 85.87 191.57"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResursiKnjiga);
export default __webpack_public_path__ + "static/media/Resursi-knjiga.8852fd4596f0bf8a88c912ecec2a2205.svg";
export { ForwardRef as ReactComponent };